import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const sectionClients = () => {
  const s = Snap('.js-client-anim');
  if (s) {
    const offset =
      (document.querySelector('body').offsetWidth -
        document
          .querySelector('.js-client-anim')
          .parentElement.querySelector('.o-wrapper').offsetWidth) /
      2;
    createTriangle(s, 70, 120, offset, 120, 10);
  }
};

export default sectionClients;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-clients.js